import React from 'react';
import "./skills.css";
import {BsFillCheckCircleFill} from 'react-icons/bs'

const Skills = () => {
  return (
    <section id='skills'> 
    <br/>
    <h2>My Skills</h2>

    <div className='container skills_container'>
      <div className='skills_frontend'>
        <h3>Frontend Development</h3>
        <div className='skills_content'>
          <article className='skills_details'>
          <BsFillCheckCircleFill className='skills_details-icon'/>
          <div>
          <h4>HTML</h4>
          <small className='text-light'>Experienced</small>
          </div>
          </article>
          <article className='skills_details'>
          <BsFillCheckCircleFill className='skills_details-icon'/>
          <div>
          <h4>CSS</h4>
          <small className='text-light'>Experienced</small>
          </div>
          </article>
          <article className='skills_details'>
          <BsFillCheckCircleFill className='skills_details-icon'/>
         <div>
         <h4>Bootstrap</h4>
          <small className='text-light'>Experienced</small>
         </div>
          </article>
          <article className='skills_details'>
          <BsFillCheckCircleFill className='skills_details-icon'/>
          <div>
          <h4>JavaScript</h4>
          <small className='text-light'>Experienced</small>
          </div>
          </article>
          <article className='skills_details'>
          <BsFillCheckCircleFill className='skills_details-icon'/>
          <div>
          <h4>Angular</h4>
          <small className='text-light'>Experienced</small>
          </div>
          </article>
          <article className='skills_details'>
          <BsFillCheckCircleFill className='skills_details-icon'/>
         <div>
         <h4>React</h4>
          <small className='text-light'>Experienced</small>
         </div>
          </article>
        </div>
      </div>
      <div className='skills_backend'>
      <h3>Backend Development</h3>
      <div className='skills_content'>
          <article className='skills_details'>
          <BsFillCheckCircleFill className='skills_details-icon'/>
          <div>
          <h4>Csharp</h4>
          <small className='text-light'>Intermediate</small>
          </div>
          </article>
          <article className='skills_details'>
          <BsFillCheckCircleFill className='skills_details-icon'/>
          <div>
          <h4>Java</h4>
          <small className='text-light'>Intermediate</small>
          </div>
          </article>
          <article className='skills_details'>
          <BsFillCheckCircleFill className='skills_details-icon'/>
          <div>
          <h4>MySQL</h4>
          <small className='text-light'>Intermediate</small>
          </div>
          </article>
          <article className='skills_details'>
          <BsFillCheckCircleFill className='skills_details-icon'/>
          <div>
          <h4>Microsoft SQL Server</h4>
          <small className='text-light'>Intermediate</small>
          </div>
          </article>
          <article className='skills_details'>
          <BsFillCheckCircleFill className='skills_details-icon'/>
         <div>
         <h4>.Net Core</h4>
          <small className='text-light'>Experienced</small>
         </div>
          </article>
          <article className='skills_details'>
          <BsFillCheckCircleFill className='skills_details-icon'/>
          <div>
          <h4>ASP .Net Core</h4>
          <small className='text-light'>Experienced</small>
          </div>
          </article>
        </div>
      </div>

    </div>
  </section>
  )
}

export default Skills